import Report from './report.container'

export default Report